/**
 * Lazy Loading Module
 * Implements lazy loading functionality for DFP Ads
 * version 2.1.4
 * 
 * Using Semantic Versioning, please update accordingly to keep files in sync across code bases
 * 
 * Given a version number MAJOR.MINOR.PATCH, increment the:
 *  1. MAJOR version when you implement a full re-build of the architecture,
 *  2. MINOR version when you add functionality, and
 *  3. PATCH version when you implement bug fixes or make small  tweaks to current functionality.
 */
define('AdModules/lazyloading',[
    "jquery",
    "underscore",
    "utilities",
    "logging",
    "AdPlatforms/dfp",
    "AdModules/headerbidding"
], function($, _, utilities, logging, dfp, headerbidding) {
    "use strict";
    var _ModuleName = "DFP LazyLoading Module";

    var _config = { }
    var _data = {
        slots: [],
        pageconfig: {},
        throttled: null,
        complete: false
    }

    /**
     * Get configuration data off config object
     * @param {Config} config Configuration object
     */
    var init = function( config ) {
        $.extend(_config, config.lazyload);

        // test if global lazy loading should be used
        if (_config.global && _config.global.enabled) {
            // if so, leave it enabled and log to the console
            ;

            if (_useGlobalLazyLoading()) {
                ;
            } else {
                ;
                // if not, disable global lazy loading
                _config.global.enabled = false;
            }
        } else {
            ;
        }

        if (_config.onPageLoad && _config.onPageLoad.enabled
                && (!_config.onPageLoad.requireGlobal || (_config.onPageLoad.requireGlobal && _config.global.enabled))) {
            _handleOnPageLoad();
        }
    }

    var _useGlobalLazyLoading = function() {
        // if global lazy loading is enabled
        if (_config.global.enabled) {
            // test delivery rate to see if we need to activate feature

            // check for query parameter to override delivery rate and force global lazy loading
            var belazy = utilities.getParameter(document.URL, "belazy");
            if (belazy == "true") { return true; }

            // ensure rate is set
            if (_config.global.rate) {
                // if rate set to 100%, return true
                if (_config.global.rate == 1.0) return true;

                // if rate set to 0%, return false
                if (_config.global.rate == 0.0) return false;

                // if invalid rate set, return false
                if (_config.global.rate < 0.0 || _config.global.rate > 1.0) return false;

                // test against delivery rate
                return Math.random() < _config.global.rate;
            }
        }

        return false;
    }

    var _handleOnPageLoad = function() {
        if (_config.onPageLoad.enabled) {
            ;
            $(window).load(function() {
                ;
                if (_config.onPageLoad.delay > 0) {
                    ;
                    setTimeout(_loadRemainingSlots, _config.onPageLoad.delay);
                } else {
                    _loadRemainingSlots();
                }
            });
        }
    }

    var _loadRemainingSlots = function() {
        ;
        // call lazy load function while forcing it to load all slots
        _handleLazyLoad(true);
    }

    /**
     * Kicks off the lazyload handler on window scroll if slots are defined
     */
    var start = function( pageconfig ) {
        // Store page config
        _data.pageconfig = pageconfig;

        if (_data.slots.length > 0) {
            ;
            _data.throttled = _.throttle(function() {
                if (!_data.complete) {
                    _handleLazyLoad(false);
                }
            }, _config.throttle);
            $(window).scroll(_data.throttled);
        } else {
            ;
        }
    }

    /**
     * Register an ad slot for lazy loading
     * @param {AdSlot} slot Ad slot object
     */
    var registerSlot = function( slot ) {
        _data.slots.push(slot);
        ;
    }

    /**
     * Check if this slot is eligible for lazy loading based on it's position value
     * @param {AdSlot} slot Ad Slot object
     */
    var isEligibleForLazyLoad = function( slot ) {
        // out of page slots are not eligible for lazy loading
        if (slot.outofpage) { return false; }

        // if slot is roadblock or contains the number 4 in the position name, the slot is not eligible
        if (slot.roadblock == 'yes' || slot.position.includes('4')) { return false; }

        return _config.global.enabled || (_config.eligible.length > 0 && _config.eligible.includes(slot.position));
    }

    /**
     * Handle lazy load on scroll
     */
    var _lazylock = false;
    var _refreshcount = 0;
    var _handleLazyLoad = function (forceLoadAll) {
        // If lazy loading lock enabled, skip handler
        if (_lazylock) return;

        // default forceLoadAll to false so normal lazy loading is done
        if (typeof forceLoadAll == 'undefined') {
            forceLoadAll = false;
        }

        // if all slots are loaded, cancel the throttled scroll detection
        var remaining = _data.slots.map(function(s) { return s.loaded; }).filter(function(isLoaded) { return !isLoaded; });
        if (remaining.length == 0) {
            ;
            _data.complete = true;
        }

        // enable lazy loading resource lock
        _lazylock = true;
        var loading = [];
        for(var i = 0; i < _data.slots.length; i++) {
            var slot = _data.slots[i];
            if (!slot.loaded && (forceLoadAll || isInView( slot ))) {
                ;
                loading.push(slot);
            }
        }

        if (loading.length > 0) {
            if(dfp.loadSlots(loading, _data.pageconfig)) {
                ;

                // Create Ready Monitor for DFP Refresh
                var readyMonitorName = 'dfprefresh' + (++_refreshcount);
                utilities.registerReadyMonitor(readyMonitorName, function () {
                    ;
                    // Call Refresh
                    dfp.refreshSlots(loading);

                    // disable lazy loading resource lock
                    _lazylock = false;
                });

                headerbidding.refresh(loading, readyMonitorName);
            } else {
                logging.error("Something went wrong loading the slots", _ModuleName);
            }
        } else {
            // enable lazy loading resource lock
            _lazylock = false;
        }
    }

    /**
     * Check if element is in view for the initial load
     */
    var isInView = function( slot ) {
        var $elem = $('#' + slot.id);
        if($elem.length > 0) {
            // don't trust offset unless greater than 0
            // this happens while dom is still loading
            if ($elem.offset().top > 0) {
                return $elem.offset().top <= window.innerHeight + window.scrollY + _config.offset;
            }
        } else {
            logging.warn("Unable to check if in view, no dom object for slot id " + slot.id, _ModuleName);
        }

        return false;
    }

    /**
     * Removes slot from being tracked
     */
    var removeSlot = function (slot) {
        try {
            var index = _data.slots.findIndex(function(s) { return s.id == slot.id; });
            if(index >= 0) {
                ;
                _data.slots.splice(index, 1);
                ;
            }                
        } catch (error) {
            logging.error("Failed to remove slot", _ModuleName);
            logging.error(error, _ModuleName);
        }
    }

    return {
        init: init,
        start: start,
        registerSlot: registerSlot,
        enabled: (function() { return _config.enabled; }),
        isEligibleForLazyLoad: isEligibleForLazyLoad,
        isInView: isInView,
        removeSlot: removeSlot,
        isGlobal: (function() { return _config.global && _config.global.enabled; })
    }
});
